import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import "../styles/stories.css";
import NavBar from "./NavBar";

export default function StoriesList() {
  const [stories, setStories] = useState([]);
  const db = getFirestore();

  useEffect(() => {
    const fetchStories = async () => {
      const q = query(
        collection(db, "stories"),
        where("published", "==", true),
      );
      const snap = await getDocs(q);
      setStories(snap.docs.map((doc) => doc.data()));
    };
    fetchStories();
  }, [db]);

  return (
    <>
      <NavBar />

      <div className="stories-wrapper">
        {stories.map((story) => (
          <a
            key={story.slug}
            href={`/api/story/${story.slug}`}
            className="story-item"
          >
            <div className="story-ring">
              <img src={story.coverImageUrl} alt={story.title} />
            </div>
            <span className="story-title">{story.title}</span>
          </a>
        ))}
      </div>
    </>
  );
}
